<template>
    <v-layout row>
        <v-dialog v-model="dialog" persistent max-width="800px">
            <v-btn
                    fab
                    dark
                    small
                    color="primary"
                    slot="activator"
            >
                <v-icon>edit</v-icon>
            </v-btn>
            <v-card>
                <form v-on:submit.prevent="create">
                    <v-card-title>
                        <span class="headline">Add new product</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs6 s6 md6>
                                    <v-text-field
                                            v-validate="'required'"
                                            v-model="data.lc_code"
                                            :error-messages="errors.collect('data.lc_code')"
                                            label="LC CODE:"
                                            data-vv-name="data.lc_code"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs6 s6 md6>
                                    <v-text-field
                                            v-validate="'required'"
                                            v-model="data.ftn_code"
                                            :error-messages="errors.collect('data.ftn_code')"
                                            label="SUPPLIER CODE:"
                                            data-vv-name="data.ftn_code"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs6 s6 md6>
                                    <v-text-field
                                            v-validate="'required'"
                                            v-model="data.name"
                                            :error-messages="errors.collect('data.name')"
                                            label="Name"
                                            data-vv-name="data.name"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs6 s6 md6>
                                    <v-text-field
                                            v-validate="'required'"
                                            v-model="data.quantity"
                                            :error-messages="errors.collect('data.quantity')"
                                            label="Nº samples"
                                            data-vv-name="data.quantity"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs6 s6 md6>
                                    <v-text-field
                                            v-validate="'required'"
                                            v-model="data.enter_parameters"
                                            :error-messages="errors.collect('data.enter_parameters')"
                                            label="Enter parameters"
                                            data-vv-name="data.enter_parameters"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs6 s6 md6>
                                    <v-text-field
                                            v-validate="'required'"
                                            v-model="data.fruit_content"
                                            :error-messages="errors.collect('data.fruit_content')"
                                            label="Fruit content (%)"
                                            data-vv-name="data.fruit_content"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs6 s6 md6>
                                    <v-autocomplete
                                            v-validate="'required'"
                                            v-model="data.sample_priority_id"
                                            :items="priorities"
                                            :error-messages="errors.collect('data.sample_priority_id')"
                                            label="Priority"
                                            data-vv-name="data.sample_priority_id"
                                            item-text="name"
                                            item-value="id"
                                    >
                                    </v-autocomplete>
                                </v-flex>

                                <v-flex xs6 s6 md6>
                                    <v-autocomplete
                                            v-validate="'required'"
                                            v-model="data.sample_application_id"
                                            :items="applications"
                                            :error-messages="errors.collect('data.sample_application_id')"
                                            label="Application"
                                            data-vv-name="data.sample_application_id"
                                            item-text="name"
                                            item-value="id"
                                    >
                                    </v-autocomplete>
                                </v-flex>

                                <v-flex xs6 s6 md6>
                                    <v-autocomplete
                                            v-validate="'required'"
                                            v-model="data.sample_type_of_project_id"
                                            :items="projects"
                                            :error-messages="errors.collect('data.sample_type_of_project_id')"
                                            label="Type of project"
                                            data-vv-name="data.sample_type_of_project_id"
                                            item-text="name"
                                            item-value="id"
                                    >
                                    </v-autocomplete>

                                </v-flex>

                                <v-flex xs6 s6 md6>
                                    <v-text-field
                                            v-validate="'required'"
                                            v-model="data.target_price"
                                            :error-messages="errors.collect('data.target_price')"
                                            label="Target price per MT/CFR"
                                            data-vv-name="data.target_price"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs6 s6 md6>
                                    <v-text-field
                                            v-validate="'required'"
                                            v-model="data.project_potential_volume"
                                            :error-messages="errors.collect('data.project_potential_volume')"
                                            label="Project potential volume"
                                            data-vv-name="data.project_potential_volume"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs12 s12 md12>
                                    <v-textarea
                                            v-validate="'required'"
                                            :error-messages="errors.collect('data.notes')"
                                            box
                                            name="input-7-4"
                                            label="Notes"
                                            v-model="data.notes"
                                            data-vv-name="data.notes"
                                    ></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click.native="cancel()">Cancel</v-btn>
                        <v-btn color="blue darken-1" flat type="submit">Save</v-btn>
                    </v-card-actions>
                </form>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    export default {
        props: ['sample_order_id', 'product'],
        data: () => ({
            data: null,
            dialog: false,
            projects: [],
            applications: [],
            priorities: []
        }),
        created () {
            this.getPriorities();
            this.getApplications();
            this.getProjects();
            this.data = this.product;
        },
        methods: {
            getPriorities () {
                this.$store.dispatch('selectPrioritySamples').then((res) => {
                    this.priorities = res.data;
                }).catch((error) => {
                });
            },
            getApplications () {
                this.$store.dispatch('selectApplicationSamples').then((res) => {
                    this.applications = res.data;
                }).catch((error) => {
                });
            },
            getProjects () {
                this.$store.dispatch('selectProjectSamples').then((res) => {
                    this.projects = res.data;
                }).catch((error) => {
                });
            },
            create () {
                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.$store.dispatch('updateSampleOrderLine', {
                            sample_order_id: this.sample_order_id,
                            product_id: this.product.id,
                            data: this.data
                        }).then((res) => {
                            this.data = {
                                reference : '',
                                ftn_code: '',
                                quantity: '',
                                enter_parameters: '',
                                fruit_content: '',
                                sample_priority_id: '',
                                sample_application_id: '',
                                sample_type_of_project_id: '',
                                target_price: '',
                                project_potential_volume: '',
                                notes: '',
                                sample_order_id: ''
                            };
                            this.dialog = false
                        }).catch((error) => {

                        });
                    }
                });
            },
            cancel () {
                this.dialog = false;
                this.data = {
                    reference : '',
                    ftn_code: '',
                    quantity: '',
                    enter_parameters: '',
                    fruit_content: '',
                    sample_priority_id: '',
                    sample_application_id: '',
                    sample_type_of_project_id: '',
                    target_price: '',
                    project_potential_volume: '',
                    notes: '',
                    sample_order_id: ''
                };
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fnt/samples/components/EditProductComponent.vue